export class TableEnum {
  static STATES = 'states';
  static AGENCIES = 'agencies';
  static USERS = 'users';
  static REVISIONS = 'revisions';
  static GLOBALS = 'globals';
  static ENTITIES = 'entities';
}
